import { useTranslate } from "@refinedev/core";
import { Button, Flex, Typography } from "antd";
import React from "react";
import { useRegenerateMedia } from "../hooks/useRegenerateMedia";
import { useAntTheme } from "hooks/useAntTheme/";

interface projectDetailsInterface {
  mediaId: string;
  projectId: string;
  mediaStatus: string;
}

interface ProjectErrorProps {
  refetchProjectDetail: () => void;
  projectDetails: projectDetailsInterface;
}

export const ProjectError: React.FC<ProjectErrorProps> = ({
  refetchProjectDetail,
  projectDetails,
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  const { handleRegenerateMedia, isRegenerating } = useRegenerateMedia(
    refetchProjectDetail,
    projectDetails.mediaId,
    projectDetails.projectId,
    projectDetails.mediaStatus
  );

  return (
    <Flex vertical align="center">
      <Typography.Text style={{ color: theme.colorTextBaseRedesign }}>
        {t("projects.components.ProjectError.mediaGenerationFailed")}
      </Typography.Text>
      <Button
        style={{ marginTop: "16px", maxWidth: "175px", marginBottom: "25px" }}
        size="middle"
        shape="round"
        loading={isRegenerating}
        disabled={isRegenerating}
        onClick={() => handleRegenerateMedia()}
      >
        {t("media.projects.detail.regenerateVideo")}
      </Button>
    </Flex>
  );
};
